<template>
  <div id="markdown-page">
    <div class="content-with-spacing help-page-container">
      <div class="top-breadcrumb">
        <router-link :to="{ name: 'help' }">Help</router-link>
        <span class="breadcrumb-divider"><i class="fas fa-angle-right" aria-hidden="true"></i></span>
        <a class="current-page">{{ title }}</a>
      </div>
      <div class="panel panel-default">
        <div class="panel-body">
          <div v-if="markdownContent" v-html="markdownContent"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.panel {
  margin-top: 30px;
}
</style>

<script>
import { marked } from 'marked';
import { importImage } from '@utils/dynamic-image-importer';

export default {
  name: 'MarkdownViewer',
  props: {
    title: {
      type: String,
      required: true,
    },
    markdownContentRaw: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      markdownContent: null,
      markdownContentReady: false,
    };
  },
  watch: {
    markdownContentReady(newVal) {
      if (newVal) {
        this.$Loading.finish();
      } else {
        this.$Loading.start();
      }
    },
    markdownContentRaw() {
      this.renderMarkdown();
    },
  },
  beforeMount() {
    this.renderMarkdown();
  },
  methods: {
    renderMarkdown() {
      this.markdownContentReady = false;
      const processedMarkdown = this.markdownContentRaw.replace(
        /!\[([^\]]*)\]\(\/src\/img\/([^)]+)\)/g,
        (match, alt, path) => `![${alt}](${importImage(path)})`,
      );
      this.markdownContent = marked(this.$kpurify.sanitise(processedMarkdown));
      this.markdownContentReady = true;
    },
  },
};
</script>
